import { createSlice } from '@reduxjs/toolkit';
import { HttpMethod } from '../../../Asset/httpMethod';
import { startLoader, stopLoader } from '../Utility/loaderSlice';
import { AlertPopup, errorPopup } from '../../../Asset/common';

export const TableName = "AspNetRoles"

export const fetchData = (isMessage) => async (dispatch) => { 
  dispatch(startLoader())
  let ObjJsonDet = {
    jsonObj1: [{}],
    SPName: "API_RoleMastGet"
  };
  let res = await HttpMethod.post(`/SystemConfig/InsUpdDel/DynSpExDisp`, ObjJsonDet)
  if (res?.status === 200) {
    if (!(res.data.DynDisp) && isMessage) {
      errorPopup(res.data)
      dispatch(getData({ DynDisp: [] }));
    }
    else {
      dispatch(getData(await res.data));
    } 
  }
  dispatch(stopLoader())
};
const constructDataJson = (data) => {
  let newData = {};
  for (let key in data) {
    newData[key.toLowerCase()] = data[key];
  }

  let dataJson = {};
  dataJson["jsonObj"] = [];
  dataJson["TableName"] = TableName;
  dataJson["jsonObj"].push(newData);
  return dataJson;
};

const convertKeysToUpperCase = (data) => {
  if (Array.isArray(data)) {
    return data.map(item => convertKeysToUpperCase(item));
  } else if (typeof data === 'object' && data !== null) {
    const transformedData = {};
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        transformedData[key.toUpperCase()] = convertKeysToUpperCase(data[key]);
      }
    }
    return transformedData;
  }
  return data; // return primitive data types (string, number, etc.) unchanged
};

export const addData = (data) => async (dispatch) => {
  const res = await HttpMethod.post('/SystemConfig/InsUpdDel/DynSpEx', data);
  if (res?.status === 200) {
    AlertPopup.SuccessPopup(res.data)
    dispatch(fetchData());
  }
};

export const updateData = (data) => async (dispatch) => {
  dispatch(startLoader())
  const dataJson = constructDataJson(data);
  const res = await HttpMethod.post('/SystemConfig/InsUpdDel/Update', dataJson);
  if (res?.status === 200) {
    AlertPopup.SuccessPopup(res.data);
    dispatch(fetchData())
  }
  dispatch(stopLoader())
};
export const deleteData = (data) => async (dispatch) => {
  dispatch(startLoader())
  const dataJson = constructDataJson(data);
  const res = await HttpMethod.post('/SystemConfig/InsUpdDel/Delete', dataJson);
  if (res?.status === 200) {
    AlertPopup.SuccessPopup(res.data);
    dispatch(fetchData())
  }
  dispatch(stopLoader())
}

export const RoleSlice = createSlice({
  name: 'RoleSlice',
  initialState: {},
  loading: false,
  reducers: {
    getData: (state, action) => {
      return { ...action.payload };
    }
  },
});

export const { getData } = RoleSlice.actions;
export default RoleSlice.reducer;